const profile_Pic = "userFiles/profilePics";

export { profile_Pic };
